/* global Conekta, Stripe */
import { analytics } from '@src/services/Analytics'

export default function generateTokens (card) {
  validateCard(card)
  initializePaymentProviders()

  const tokenPromises = [
    generateConektaToken({ card }),
    generateStripeToken(card)
  ]

  return Promise.all(tokenPromises).then(([conekta, stripe]) => {
    return {
      conekta,
      stripe
    }
  })
}

function validateCard (card) {
  return
}

function initializePaymentProviders () {
  Conekta.setPublishableKey(process.env.CONEKTA_PUBLISHABLE_KEY)
  Stripe.setPublishableKey(process.env.STRIPE_PUBLISHABLE_KEY)
}

function generateConektaToken (card) {
  // required tokenParams params: { card: { number, name, cvc, exp_month, exp_year } }
  return new Promise((resolve) => {
    const onResponseSuccess = (response) => {
      analytics.paymentTokenGenerationSuccess({
        paymentProvider: 'conekta'
      })

      return resolve(response.id)
    }

    const onResponseFailure = (error) => {
      analytics.paymentTokenGenerationFailure({
        paymentProvider: 'conekta'
      })

      return resolve({
        error: {
          details: { ...error },
          message: error.message_to_purchaser
        }
      })
    }

    Conekta.token.create(card, onResponseSuccess, onResponseFailure)
  })
}

function generateStripeToken (card) {
  // required card params: { number, cvc, exp_month, exp_year }
  return new Promise((resolve) => {
    Stripe.card.createToken(card, (status, response) => {
      if (response.error) {
        analytics.paymentTokenGenerationFailure({
          paymentProvider: 'stripe'
        })

        return resolve({
          error: {
            details: { ...response.error },
            message: response.error.message
          }
        })
      }

      analytics.paymentTokenGenerationSuccess({
        paymentProvider: 'stripe'
      })
      return resolve(response.id)
    })
  })
}



// WEBPACK FOOTER //
// ./src/services/payment/payment.js